"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrequencySelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _helpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers");
var _quoteHelpers = require("../../helpers/quoteHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var FrequencySelector = exports.FrequencySelector = function FrequencySelector(_ref) {
  var selectedFrequency = _ref.selectedFrequency,
    collectionFee = _ref.collectionFee,
    formContext = _ref.formContext,
    dataIsUpdating = _ref.dataIsUpdating,
    _ref$onPaymentFrequen = _ref.onPaymentFrequencyChange,
    onPaymentFrequencyChange = _ref$onPaymentFrequen === void 0 ? function () {} : _ref$onPaymentFrequen;
  var hookFormContext = (0, _reactHookForm.useFormContext)();
  var radioFormContext = formContext || hookFormContext;
  var _useState = (0, _react.useState)(selectedFrequency),
    _useState2 = _slicedToArray(_useState, 2),
    frequency = _useState2[0],
    setFrequency = _useState2[1];
  var HandleFrequencyChange = function HandleFrequencyChange(newFrequency) {
    if (frequency !== newFrequency) {
      setFrequency(newFrequency);
      onPaymentFrequencyChange(newFrequency);
    }
  };
  var radioProps = {
    groupName: 'paymentFrequency_radios',
    name: 'paymentFrequency_radios',
    groupLabel: 'The payment frequency I prefer is:',
    disabled: dataIsUpdating,
    radioInputs: Object.entries(_quoteHelpers.FREQUENCIES).map(function (_ref2, index) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      return {
        labelCssClass: {
          checked: 'button labelText frequencySelector',
          unchecked: 'button labelText frequencySelector'
        },
        label: "".concat(value.frequencyDisplayText).concat(value.collectionFee && collectionFee && collectionFee > 0 ? '*' : ''),
        value: key,
        id: "paymentFrequency_radios_".concat(key)
      };
    }),
    onChange: HandleFrequencyChange,
    value: frequency
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "paymentFrequencySelector ".concat(dataIsUpdating ? 'dataIsUpdating' : '')
  }, /*#__PURE__*/_react["default"].createElement(_components.StyledRadios, _extends({}, radioProps, {
    fieldFormContext: radioFormContext
  })), dataIsUpdating && /*#__PURE__*/_react["default"].createElement(_components.Spinner, null), collectionFee > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "collectionFeeNote"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("sup", null, "*"), "If you choose to pay by instalments, you will incur a ", (0, _helpers.FormatAsCurrencyForLocale)(collectionFee), " collection fee per instalment.")));
};
FrequencySelector.propTypes = {
  selectedFrequency: _propTypes["default"].string,
  collectionFee: _propTypes["default"].number,
  dataIsUpdating: _propTypes["default"].bool,
  onPaymentFrequencyChange: _propTypes["default"].func,
  /* eslint-disable-next-line react/forbid-prop-types */
  formContext: _propTypes["default"].any
};